const init = () => {
    const playPauseBtn = document.querySelectorAll('.play-pause');

    [...playPauseBtn].forEach(btn => {
        const parentSelector = btn.closest('.hero');
        const bgVideo = parentSelector.getElementsByTagName('video')[0];

        btn.addEventListener('click', function () {
            if (this.classList.contains('hero__video-btn--pause')) {
                this.classList.remove('hero__video-btn--pause');
                bgVideo.play();
            } else {
                this.classList.add('hero__video-btn--pause');
                bgVideo.pause();
            }
        });
    });
};

export {
    init
};
